import { useField } from 'react-final-form'
import { composeValidators, selectRequired } from '../../utilities/validate'
import useTranslate from '../../i18n/useTranslate'
// import { useType } from './multiSelectType'

export type FieldRequired = boolean | { showAsterisk?: boolean; triggedValidate?: boolean; errorMessage?: string }

const useSelect = (props: any) => {
    const { name, required, validates = [] } = props
    const translate = useTranslate()
    let mergeValidate = validates
    if ((typeof required === 'boolean' && required) || (typeof required === 'object' && required.triggedValidate)) {
        mergeValidate = [
            selectRequired(typeof required === 'object' ? required.errorMessage : `${translate.get('MESSAGE.M016')}`),
            ...mergeValidate,
        ]
    }

    const field = useField<any>(name, {
        validate: composeValidators(...mergeValidate),
    })

    return { field }
}

export default useSelect
